// 硕博可以有的角色
export const masterRoles = ['EM', 'CM', 'SM']
// 本科可以有的角色
export const ugdRoles = ['UGDEM', 'UGDCM', 'UGDFAO']
